import VuexPersistence from "vuex-persist";
import { vuexPersistConfig } from "@/config";

/**
 * Vuex store persist config
 * @description Persists the Vuex store in browser storage
 */
const vuexPersist = new VuexPersistence(vuexPersistConfig);

export default vuexPersist;
